// import React, { useEffect, useState } from 'react';
import React, {useEffect} from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { getPartners } from '../actions/partners';
import { getPlants } from '../actions/plants';
import { getTags } from '../actions/tags';
import { getPosts } from '../actions/posts';
import { FaTimes } from 'react-icons/fa';

import { Tag, Benefit, PostsList } from './index'
import {
  useHistory,
  useLocation,
  useParams
} from "react-router-dom";
// import { useSelector  } from "react-redux";

type PropsPostDetails = {
    // Penser à crer un model pour le post
  id?: number
  layoutClasses?: string;
};

const PostDetails: React.FC<PropsPostDetails> = () => {

  let history = useHistory();
  const { id } = useParams()
  const { categorie } = useParams()

  const dispatch = useDispatch();

  useEffect(() => {
      dispatch(getPartners())
      dispatch(getPlants())
      dispatch(getTags())
      dispatch(getPosts())
    }, [dispatch])

  //Rename postDetail to Detail
  const element = useSelector((state: any) => categorie === 'posts' ? state.posts.find(post => post._id === id) : state.plants.find(post => post._id === id))
  const postTags = useSelector((state: any) => element ? state.tags.filter(tag => element.tags ? element.tags.includes(tag._id) : ''): console.log('still loading'))
  const postPlants = useSelector((state: any) => element ? state.plants.filter(plant => element.plants ? element.plants.includes(plant._id) : ''): console.log('still loading'))
  const postPartners = useSelector((state: any) => element ? state.partners.filter(partner => element.partners ? element.partners.includes(partner._id) : ''): console.log('still loading'))
  const plantBenefits = useSelector((state: any) => element ? state.benefits.filter(benefit => element.benefits ? element.benefits.includes(benefit._id) : ''): console.log('still loading'))

  //Corriger (post.images) et (plant.image)
  const imagePost =element ? element.images ? element.images : '' : 'still loading';
  const imagePlant = element ? element.image ? element.image : '' : 'still loading';

  return (
    <>
      {element && (

      <div draggable="true" className="_flex _flex-col _relative _w-full _h-full _overflow-auto">
        <div className="_bg-green _rounded-t-card _bg-no-repeat _bg-cover _absolute _w-full _bg-center" style={{ height: '250px', backgroundImage: `url(${imagePost || imagePlant})` }}>
          <div className="_d-flex _flex-col _p-sm _rounded-t-card background-brightness _h-full">
              <button onClick={() => history.goBack()} className="_bg-white _rounded-circle _flex _justify-center _items-center _opacity-60" style={{ width: '30px', height:'30px' }}>
              <FaTimes/> 
            </button>
            <div className="_bottom-sm _absolute">
              {postTags.length ? (
                <div className="_flex _flex-wrap">
                    <Tag isForm={false} elements={postTags[0]} />
                </div>
              ) : ''}
              <h1 className="_text-white">{element.title}</h1>
            </div>
          </div>
        </div>
        <div className="_bg-white _rounded-md _w-full _shadow-xl  _flex _flex-col _h-auto _absolute" style={{ top: '234px' }}>
          {/* Si ce n'est pas une plante alors on affiche les infos de l'îlot */}
          {!element.benefits ? (
              <div>
                <div className="_p-sm">
                  <div className="_mb-sm _overflow-hidden">
                    <h2>Objectifs</h2>  
                    <p>{element.goals}</p>
                  </div>
                  <div>
                    <h2>Essences plantées</h2>  
                    {postPlants.length > 0 && (
                      <div className="_flex _flex-wrap">
                        {postPlants.map(element => (
                          <Tag isPlant={true} isForm={false} elements={element} />
                        ))} 
                      </div>
                    )}
                  </div>
                  <div className="_mb-sm _overflow-hidden">
                    <h2>Méthode de travail</h2>  
                    <p>{element.working_method}</p>
                  </div>
                  <div>
                    <h2>Partenaires</h2> 
                    <p>Ils financent nos ôlots etc, consectetur adipiscing elit, sed do ei ...</p>
                    {postPartners.length > 0 && (
                      <div className="_flex _flex-wrap">
                        {postPartners.map(element => (
                          <a rel="noreferrer" target="_blank" href={element.link}>
                            <div className="_mr-xs _mt-xs _bg-white _shadow-md _bg-no-repeat _bg-contain _bg-center _rounded-md" style={{ height: '60px', width: '60px', backgroundImage: `url(${element.image})` }}/>
                          </a>
                        ))} 
                      </div>
                    )}
                  </div>

                </div>
                <div>
                    <h2 className="_pl-sm">Autres ilots</h2> 
                    <div className=" _overflow-hidden margin-footer">
                      <PostsList />
                    </div>
                </div>
              </div>
            
            ) : (
                <div className="_p-sm" >
                  <p>{element.description}</p>
                  <div className="_mb-sm">
                    <h2>Bénéfices</h2>  
                    {plantBenefits.length > 0 && (
                      <div className="_flex _flex-col margin-footer">
                        {plantBenefits.map(element => (
                          <div>
                            <Benefit isForm={false} key={element._id} benefit={element} />
                          </div>
                        ))} 
                      </div>
                    )}
                  </div>
                </div>
          )}
        </div>
      </div>
      )}

    </>
  );
};

export default PostDetails;
